"use client";

import { c as _c } from "react-compiler-runtime";
import { motion } from "motion/react";
type GlowOverlayProps = {
  color?: string;
};
export default function GlowOverlay(t0) {
  const $ = _c(18);
  const {
    color
  } = t0;
  const glowColor = color ?? "hsl(var(--primary))";
  let t1;
  if ($[0] !== glowColor) {
    t1 = glowColor.replace(")", " / 0)");
    $[0] = glowColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `0 0 0 0 ${t1}`;
  let t3;
  if ($[2] !== glowColor) {
    t3 = glowColor.replace(")", " / 0.4)");
    $[2] = glowColor;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `0 0 30px 10px ${t3}`;
  let t5;
  if ($[4] !== glowColor) {
    t5 = glowColor.replace(")", " / 0)");
    $[4] = glowColor;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `0 0 0 0 ${t5}`;
  let t7;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== t6) {
    t7 = {
      boxShadow: [t2, t4, t6]
    };
    $[6] = t2;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== glowColor) {
    t8 = glowColor.replace(")", " / 0)");
    $[10] = glowColor;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `0 0 0 0 ${t8}`;
  let t10;
  if ($[12] !== t9) {
    t10 = {
      boxShadow: t9
    };
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      duration: 1.5,
      repeat: Infinity
    };
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t7) {
    t12 = <motion.div animate={t7} className="absolute inset-0 rounded-2xl" initial={t10} transition={t11} />;
    $[15] = t10;
    $[16] = t7;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}